/**
 * Dummy data for Student Distribution (used when API is not available).
 * TODO: Remove and use real API when backend is ready.
 */

import type {
  StudentSummaryCardItem,
  StaffSummaryCardItem,
  StudentAggregatePresencePoint,
  StaffAggregatePresencePoint,
} from "./distributionService";

export const DUMMY_LOCATIONS = [
  { id: "loc-1", name: "Main Building" },
  { id: "loc-2", name: "Science Block" },
  { id: "loc-3", name: "Library" },
  { id: "loc-4", name: "Sports Complex" },
  { id: "loc-5", name: "Cafeteria" },
];

export const DUMMY_STUDENT_SUMMARY_CARDS: StudentSummaryCardItem[] = [
  {
    title: "Current Presence",
    value: "24",
    subtitle: "students currently present",
    locations: [
      { name: "Main Building", value: 12 },
      { name: "Science Block", value: 6 },
      { name: "Library", value: 4 },
      { name: "Sports Complex", value: 2 },
    ],
  },
  {
    title: "Peak Today",
    value: "156",
    subtitle: "peak count",
    timestamp: new Date().toISOString().replace(/T\d{2}:\d{2}:\d{2}.*/, "T10:30:00.000Z"),
  },
  {
    title: "Avg Dwell Time",
    value: "12.5 min",
    subtitle: "average across locations",
    locations: [
      { name: "Main Building", value: 750 },
      { name: "Science Block", value: 680 },
      { name: "Library", value: 540 },
      { name: "Sports Complex", value: 420 },
    ],
  },
  {
    title: "Peak Dwell Time",
    value: "45 min",
    subtitle: "longest session today",
  },
];

export const DUMMY_STAFF_SUMMARY_CARDS: StaffSummaryCardItem[] = [
  {
    title: "Current Presence",
    value: "8",
    subtitle: "staff currently present",
    locations: [
      { name: "Main Building", value: 4 },
      { name: "Science Block", value: 2 },
      { name: "Library", value: 1 },
      { name: "Sports Complex", value: 1 },
    ],
  },
  {
    title: "Peak Today",
    value: "22",
    subtitle: "peak count",
    timestamp: new Date().toISOString().replace(/T\d{2}:\d{2}:\d{2}.*/, "T09:15:00.000Z"),
  },
  {
    title: "Avg Dwell Time",
    value: "28 min",
    subtitle: "average across locations",
    locations: [
      { name: "Main Building", value: 1680 },
      { name: "Science Block", value: 1440 },
      { name: "Library", value: 1200 },
      { name: "Sports Complex", value: 900 },
    ],
  },
  {
    title: "Peak Dwell Time",
    value: "2h 15min",
    subtitle: "longest session today",
  },
];

function generateDummyPresencePoints(
  baseKey: "student" | "staff",
  count = 48
): StudentAggregatePresencePoint[] | StaffAggregatePresencePoint[] {
  const today = new Date();
  today.setHours(6, 0, 0, 0);
  const points: { time: string; student?: number; staff?: number }[] = [];
  for (let i = 0; i < count; i++) {
    const d = new Date(today.getTime() + i * 30 * 60 * 1000); // 30-min intervals
    const value = Math.floor(20 + Math.sin((i / count) * Math.PI) * 80 + Math.random() * 20);
    points.push({
      time: d.toISOString(),
      ...(baseKey === "student" ? { student: value } : { staff: Math.floor(value / 4) }),
    });
  }
  return points as StudentAggregatePresencePoint[] | StaffAggregatePresencePoint[];
}

export const DUMMY_STUDENT_AGGREGATE_PRESENCE =
  generateDummyPresencePoints("student") as StudentAggregatePresencePoint[];

export const DUMMY_STAFF_AGGREGATE_PRESENCE =
  generateDummyPresencePoints("staff") as StaffAggregatePresencePoint[];
